import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const levels = [{
  id: 'NIVEL 1',
  color: 'emerald',
  image: 'https://cdn.magicpatterns.com/uploads/g3inALfF68vcDUWLzxsYav/mock_up_1_completo.png',
  title: 'Manual Profesional de Perfiles de Aluminio para Puertas, Ventanas y Estructuras',
  features: ['Tipos de perfiles', 'Herramientas', 'Instalación', 'Errores comunes', 'Proyectos básicos']
}, {
  id: 'NIVEL 2',
  color: 'amber',
  image: 'https://cdn.magicpatterns.com/uploads/direkGBpxQ1cwhewkvvyAq/mockup_2.png',
  title: 'Diseño y Construcción Profesional',
  features: ['Diseño estructural', 'Cálculo de cargas', 'Sistemas avanzados', 'Planos', 'Proyectos intermedios']
}, {
  id: 'NIVEL 3',
  color: 'rose',
  image: 'https://cdn.magicpatterns.com/uploads/iayJiNPkcz2tDJSSRg4Y45/mock_up_3_completo.png',
  title: 'Negocio Profesional y Proyectos Avanzados',
  features: ['Presupuestos', 'Costos', 'Rentabilidad', 'Gestión', 'Proyectos premium']
}];
const colorMap = {
  emerald: {
    dot: 'bg-emerald-500',
    border: 'group-hover:border-emerald-500/50',
    glow: 'group-hover:shadow-[0_0_30px_rgba(16,185,129,0.2)]',
    text: 'text-emerald-400'
  },
  amber: {
    dot: 'bg-amber-500',
    border: 'group-hover:border-amber-500/50',
    glow: 'group-hover:shadow-[0_0_30px_rgba(245,158,11,0.2)]',
    text: 'text-amber-400'
  },
  rose: {
    dot: 'bg-rose-500',
    border: 'group-hover:border-rose-500/50',
    glow: 'group-hover:shadow-[0_0_30px_rgba(244,63,94,0.2)]',
    text: 'text-rose-400'
  }
};
export function Includes() {
  return <section id="niveles" className="py-24 relative z-10" data-id="element-128">
      <div className="container mx-auto px-6" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-131">
            ¿Qué incluye la colección?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-132">
            Tres niveles estructurados para llevarte desde los conceptos más
            básicos hasta la gestión de proyectos de alto valor.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-133">
          {levels.map((level, idx) => {
          const colors = colorMap[level.color as keyof typeof colorMap];
          return <motion.div key={level.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.2
          }} className={`group glass-panel rounded-3xl p-8 transition-all duration-500 ${colors.border} ${colors.glow} hover:-translate-y-2`} data-id="element-134">
                <div className="flex items-center gap-3 mb-6" data-id="element-135">
                  <div className={`w-3 h-3 rounded-full ${colors.dot} shadow-[0_0_10px_currentColor]`} data-id="element-136" />
                  <span className={`font-bold tracking-wider text-sm ${colors.text}`} data-id="element-137">
                    {level.id}
                  </span>
                </div>

                {/* Book mockup image */}
                <div className="relative flex justify-center items-center h-44 mb-6" data-id="element-138">
                  <div className="absolute inset-x-8 bottom-2 h-6 bg-black/40 blur-xl rounded-full" data-id="element-139" />
                  <motion.img src={level.image} alt={level.title} whileHover={{
                y: -6,
                rotate: -2
              }} transition={{
                type: 'spring',
                stiffness: 200,
                damping: 15
              }} className="relative h-full w-auto object-contain drop-shadow-[0_15px_30px_rgba(0,0,0,0.5)]" data-id="element-140" />
                </div>

                <h3 className="text-xl font-bold font-heading mb-6 min-h-[60px]" data-id="element-141">
                  {level.title}
                </h3>

                <div className="space-y-4" data-id="element-142">
                  {level.features.map((feature, fIdx) => <div key={fIdx} className="flex items-start gap-3" data-id="element-143">
                      <div className="mt-1 w-5 h-5 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-144">
                        <Check className="w-3 h-3 text-gray-300" data-id="element-145" />
                      </div>
                      <span className="text-gray-300" data-id="element-146">{feature}</span>
                    </div>)}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}